<template>
  <div
    v-if="editorialTeam && editorialTeam.length"
    class="relative rounded-lg overflow-hidden mt-4 sm:mt-8"
  >
    <div class="rounded-lg border border-neutral-200 bg-neutral-50">
      <div
        class="p-6 grid grid-cols-1 sm:grid-cols-2 gap-4"
        :class="{ 'pointer-events-none': hasWebView }"
      >
        <div
          v-for="(author, i) in editorialTeam"
          :key="author.id || i"
          class="flex items-center justify-start text-sm space-x-2 lg:space-x-3"
        >
          <vetster-circle-avatar
            :author="author"
            class="!size-20"
          />
          <div>
            <div class="flex flex-row items-center space-x-1">
              <a
                :href="getAuthorUrl(author)"
                class="font-semibold hover:underline transition text-ocean-950 leading-4 sm:leading-5 lg:text-base shrink-0"
              >
                {{ author.name }}
              </a>
              <fa
                v-if="author.is_editorial_team"
                :icon="['fas', 'badge-check']"
                class="text-base text-bubblegum inline-flex items-center"
              />
            </div>
            <div class="text-xs lg:text-sm mt-1 sm:mt-0">
              {{ author.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VetsterCircleAvatar from '@/brand-components/Content/VetsterCircleAvatar';
import LocalizesRoutes from '@/mixins/LocalizesRoutes';

export default {
  name: 'VetsterEditorialCommitteeTeam',

  components: { VetsterCircleAvatar },

  mixins: [LocalizesRoutes],

  props: {
    editorialTeam: {
      type: Array,
      default: () => [],
    },
    hasWebView: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    getAuthorUrl(author) {
      if (author.is_partner) {
        return author.url_website;
      }

      return this.localizeLanguageUrl(`/author/${author.slug}`);
    },
  },
};
</script>
